import * as React from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PosConsoleApi from "app/utils/PosConsoleApi";

type State = {
  isEnabled: boolean;
};

type Props = {
  provider: string;
  isEnabled: boolean;
};

export default class SmsProviderToggle extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isEnabled: this.props.isEnabled
    };
  }

  onToggle = (event, isEnabled) => {
    PosConsoleApi.post("text_messages/provider", {
      enabled: isEnabled,
      provider: this.props.provider
    })
      .then(response => {
        this.setState({ isEnabled });
      })
      .catch(error => alert(error));
  };

  render() {
    const { isEnabled } = this.state;

    const Active = () => <span style={{ color: "green" }}>Active</span>;
    const Inactive = () => <span style={{ color: "red" }}>Inactive</span>;

    return (
      <FormControlLabel
        control={<Switch checked={isEnabled} onChange={this.onToggle} />}
        label={isEnabled ? <Active /> : <Inactive />}
      />
    );
  }
}
